module.exports = __webpack_public_path__ + "static/media/inr-symb.c1efa30c.png";